<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Rewards – {{ leagueName }}</h4>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <button class="btn btn-sm btn-primary" type="button" (click)="onClickAddReward()">
            <i class="fa fa-plus"></i> Add Reward
          </button>
        </div>
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Rank</th>
              <th>Currency Type</th>
              <th>Currency Qty</th>
              <th>Ticket Cost</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading) {
              <tr>
                <td colspan="7" class="text-center">
                  <span class="spinner-border spinner-border-sm"></span> Loading...
                </td>
              </tr>
            } @else if (rewards.length === 0) {
              <tr>
                <td colspan="7" class="text-center text-muted">No rewards found.</td>
              </tr>
            } @else {
              @for (reward of rewards; track reward.rewardId; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ reward.rewardId }}</td>
                  <td>{{ reward.rank }}</td>
                  <td>{{ getCurrencyTypeName(reward.currencyType) }}</td>
                  <td>{{ reward.currencyQuantity }}</td>
                  <td>{{ reward.currencyTicketCost }}</td>
                  <td>
                    <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEditReward(reward)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                    <span class="text-muted mx-1">|</span>
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDeleteReward(reward)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>

<app-league-reward-add-modal #leagueRewardAddModal></app-league-reward-add-modal>
<app-league-reward-edit-modal #leagueRewardEditModal></app-league-reward-edit-modal>
